import React, { Fragment } from 'react'

import './styles.scss'

import backgroundImg from './img/background.jpg'
import detailImg from './img/detail.png'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName, weddingDate, coupleFirstName },
  buttonMessage,
  warningMessage,
  locale = 'pt-BR',
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const day = new Date(weddingDate.timestamp)
    .getDate()
    .toString()
    .padStart(2, '0')
  const month = new Intl.DateTimeFormat(locale, { month: 'long' })
    .format(new Date(weddingDate.timestamp))
    .toUpperCase()
  const year = new Date(weddingDate.timestamp).getFullYear()

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro134">
      <div className="bp1-intro134desktop anima-word-break ">
        <img src={background || backgroundImg} className="bp1-mainbackground" />
        <div className="bp1-mask"></div>
        <div className="bp1-content-layout-container">
          <div className="bp1-content">
            <div className="bp1-data-layout-container">
              <div className="bp1-data bp1-intro134-anima-animate-enter">
                <div className="bp1-daymonthyear">
                  {locale === 'en-US' ? (
                    <>
                      {month} {day} {year}
                    </>
                  ) : (
                    <>
                      {day} {month} {year}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="bp1-names-layout-container">
              <div className="bp1-names bp1-intro134-anima-animate-enter4">
                <div className="notranslate bp1-couplesinglenamebr bp1-intro134-anima-animate-enter1">
                  <span className="bp1-span1">{coupleSingleName.bride}</span>
                  <span className="bp1-span2"> </span>
                </div>
                {!!coupleSingleName.groom && (
                  <Fragment>
                    <div className="bp1-label1-layout-container">
                      <div className="bp1-label1 bp1-intro134-anima-animate-enter3">
                        &amp;
                      </div>
                    </div>
                    <div className="notranslate bp1-couplesinglenamegr bp1-intro134-anima-animate-enter2">
                      {coupleSingleName.groom}
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
            <div className="bp1-ornament-layout-container">
              <div className="bp1-ornament bp1-intro134-anima-animate-enter5">
                <img src={detailImg} className="bp1-fill1" />
              </div>
            </div>
          </div>
        </div>
        <div className="bp1-button-layout-container">
          <div className="bp1-button">
            <div
              className="bp1-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp1-button1" onClick={onSkipIntro}>
              <div className="bp1-button2"></div>
              <div className="bp1-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="bp2-intro134mobile anima-word-break ">
        <img src={background || backgroundImg} className="bp2-mainbackground" />
        <div className="bp2-mask"></div>
        <div className="bp2-content-layout-container">
          <div className="bp2-content">
            <div className="bp2-data-layout-container">
              <div className="bp2-data bp2-intro134-anima-animate-enter">
                <div className="bp2-daymonthyear">
                  {locale === 'en-US' ? (
                    <>
                      {month} {day} {year}
                    </>
                  ) : (
                    <>
                      {day} {month} {year}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="bp2-names-layout-container">
              <div className="bp2-names bp2-intro134-anima-animate-enter4">
                <div className="bp2-couplesinglenamebr bp2-intro134-anima-animate-enter1">
                  <span className="bp2-span1">
                    {coupleFirstName.groom
                      ? coupleFirstName.bride
                      : coupleSingleName.bride}{' '}
                  </span>
                  <span className="bp2-span2"> </span>
                </div>
                {!!coupleFirstName.groom && (
                  <Fragment>
                    <div className="bp2-label1 bp2-intro134-anima-animate-enter3">
                      &amp;
                    </div>
                    <div className="bp2-couplesinglenamegr bp2-intro134-anima-animate-enter2">
                      {coupleFirstName.groom}
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
            <div className="bp2-ornament bp2-intro134-anima-animate-enter5">
              <img src={detailImg} className="bp2-fill1" />
            </div>
          </div>
        </div>
        <div className="bp2-button-layout-container">
          <div className="bp2-button">
            <div
              className="bp2-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp2-button1" onClick={onSkipIntro}>
              <div className="bp2-button2"></div>
              <div className="bp2-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
